export default __webpack_public_path__ + "static/media/dogecoin2.7008ccc7.svg";